import ModalComponent from "components/Common/Modal";
import moment from "moment";
import React, { useMemo, useState, useRef, useEffect } from "react";
import { IoIosArrowRoundForward } from "react-icons/io";

interface IPositiveFeedbackCardProps {
  userFeedback: UserFeedbackType;
}

const PositiveFeedbackCard: React.FC<IPositiveFeedbackCardProps> = ({
  userFeedback,
}) => {
  const [readMorePopup, setReadMorePopup] = useState<UserFeedbackType | null>(
    null
  );
  const [isClamped, setIsClamped] = useState(false);
  const feedbackRef = useRef<HTMLDivElement>(null);

  const onHide = () => setReadMorePopup(null);
  const { feedback, createdAt } = userFeedback;

  useEffect(() => {
    if (feedbackRef.current) {
      const el = feedbackRef.current;
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [feedback]);

  const renderFeedbackMessage = useMemo(
    () => <div className="text-md font-regular">{feedback}</div>,
    [feedback]
  );

  return (
    <div className="bg-white shadow-sm rounded-[24px] flex flex-col gap-4 py-6 px-5 min-w-[300px] md:w-[400px]">
      <div
        ref={feedbackRef}
        className="line-clamp-4 text-md font-regular min-h-[96px] overflow-hidden flex-1"
      >
        {feedback}
      </div>

      {isClamped && (
        <div
          className="text-linkBlue font-bold cursor-pointer text-sm"
          onClick={() => setReadMorePopup(userFeedback)}
        >
          Read More
          <IoIosArrowRoundForward
            className="text-linkBlue inline-block"
            size={32}
          />
        </div>
      )}

      <div className="flex flex-row items-end">
        <p className="text-black60 font-semibold text-xs">
          {moment.utc(createdAt).format("D MMM, YYYY")}
        </p>
      </div>

      {readMorePopup && (
        <ModalComponent
          containerClass="md:w-[520px] md:h-[300px] max-h-[70vh] w-[95vw]"
          onClose={onHide}
          showClose={true}
          renderHeader={<>What people are saying</>}
        >
          {renderFeedbackMessage}
        </ModalComponent>
      )}
    </div>
  );
};

export default PositiveFeedbackCard;
